<modal class="modal-window password-recovery" [width]="'90%'" [height]="'90%'" [ignoreEscKey]="true">
  <modal-header [noCloseButton]="true">
    <span>{{title}}</span>
  </modal-header>

  <modal-body>
    <ng-container *ngIf="agreements; else tmpLoading">
      <ng-container *ngIf="agreements.length; else tmpNoAgreements">
        <ng-container *ngIf="agreements.length > 1; else tmp1Agreement">
          <kendo-tabstrip (tabSelect)="onTabSelect($event)">
            <kendo-tabstrip-tab *ngFor="let agreement of agreements; let index = index" [selected]="defaultCAId ? agreement.id === defaultCAId : index === 0" [title]="agreement.name">
              <ng-template kendoTabContent>
                <div [innerHtml]="agreement.html"></div>
              </ng-template>
            </kendo-tabstrip-tab>
          </kendo-tabstrip>
        </ng-container>
      </ng-container>
    </ng-container>
  </modal-body>

  <modal-actions>
    <ng-container *ngIf="agreements">
      <ng-container *ngIf="agreements.length">
        <button kendoButton (click)="decline()">{{ strings.notAgree }}</button>
        <button kendoButton [primary]="true" (click)="agree()">{{strings.agree}}</button>
      </ng-container>

      <ng-container *ngIf="!agreements.length">
        <button kendoButton (click)="decline()">{{ miscStrings.close }}</button>
      </ng-container>
    </ng-container>
  </modal-actions>
  <ti-spinner *ngIf="isLoading"></ti-spinner>
</modal>

<ng-template #tmpLoading ><ti-spinner></ti-spinner></ng-template>
<ng-template #tmpNoAgreements >{{strings.noAgreements}}</ng-template>
<ng-template #tmp1Agreement ><div [innerHtml]="agreements[0].html"></div></ng-template>
